module.exports = __webpack_public_path__ + "project.ef57fcde.webp";